import { render, staticRenderFns } from "./DblogsList.vue?vue&type=template&id=3041c9fe"
import script from "./DblogsList.vue?vue&type=script&lang=js"
export * from "./DblogsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports